module.exports = __webpack_public_path__ + "img/pro_night_7.dc31a61c.jpg";